var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.904 41H39.096C41.39 41 43.39 39.439 43.947 37.213L44 37H4L4.053 37.213C4.61 39.439 6.61 41 8.904 41Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 34.326V17H43C44.654 17 46 18.346 46 20V25.983C46 28.204 44.509 30.181 42.373 30.791L30 34.326ZM32 19V31.674L41.824 28.867C43.105 28.501 44 27.315 44 25.983V20C44 19.449 43.552 19 43 19H32Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37H14C14 37 9 24 9 19C9 16.75 9 10 9 10C9 9.448 9.448 9 10 9H38C38.552 9 39 9.448 39 10C39 10 39 16.75 39 19C39 24 34 37 34 37Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6C18.447 6 18 5.553 18 5V1C18 0.447 18.447 0 19 0C19.553 0 20 0.447 20 1V5C20 5.553 19.553 6 19 6Z",
    fill: "#CDD0D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 6C28.447 6 28 5.553 28 5V1C28 0.447 28.447 0 29 0C29.553 0 30 0.447 30 1V5C30 5.553 29.553 6 29 6Z",
    fill: "#CDD0D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8C23.447 8 23 7.553 23 7V4C23 3.447 23.447 3 24 3C24.553 3 25 3.447 25 4V7C25 7.553 24.553 8 24 8Z",
    fill: "#CDD0D2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24,
    y1: 37.264,
    x2: 24,
    y2: 42.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    stopColor: "#F45560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 38.107,
    y1: 25.663,
    x2: 45.388,
    y2: 25.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F45560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 21.729,
    y1: 9.07,
    x2: 28.851,
    y2: 30.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#CF1928"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe);
export default __webpack_public_path__ + "static/media/cafe.25e8a07f0f1542ad8d027821e790403f.svg";
export { ForwardRef as ReactComponent };